import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

import { ChainId, DefaultChainId, SupportChainIDs } from '@/constant';
import storage from '@/utils/storage';
import { GraphQLClient } from 'graphql-request';
// import { getSdk as getChathSdk } from './chat/__generated__/request';
import config from './config';
import { getSdk as getGraphSdk } from './graph/__generated__/request';
import { getSdk as getLazpadSdk } from './lazpad/__generated__/request';
import { getSdk as getTaskSdk } from './task/__generated__/request';

const SERVER_URL = import.meta.env.VITE_SERVER_URL;

export function getCurrentChainId(): ChainId {
    const web3ChainId = Number(
        ((window as any)?.web3 as any)?.currentProvider.chainId,
    );

    return SupportChainIDs.indexOf(web3ChainId) >= 0
        ? web3ChainId
        : DefaultChainId;
}

export function getApolloClient(key: string, chainId?: ChainId) {
    console.log('client with chain', chainId || getCurrentChainId());
    return new ApolloClient({
        cache: new InMemoryCache(),
        link: new HttpLink({
            uri: '',
        }),
    });
}

const sdkWrapper: any = async (
    action: () => Promise<any>,
    operationName: string,
    operationType?: string,
    variables?: any,
): Promise<any> => {
    return action().catch((error) => {
        const errs = (error as any)?.response?.errors;

        if (errs?.length > 0) {
            for (const err of errs) {
                if (
                    err?.extensions?.classification === 'UNAUTHORIZED' ||
                    err?.code === 401
                ) {
                    storage.remove('auth-token');
                    window.location.reload();
                }
            }
        }

        if (variables?._catchError) {
            console.error(
                'query error, method:',
                operationName,
                variables || '',
            );
        } else {
            throw error;
            // console.log(JSON.stringify(error));
            // setTimeout(() => {
            //   alert.error({
            //     title: 'Error',
            //     text: error?.response?.errors?.length
            //       ? error?.response?.errors[0]?.message
            //       : 'Something went wrong.',
            //   });
            // }, 0);
        }
    });
};
export function getServerApi(chainId?: ChainId, noAuth?: boolean) {
    const authData = storage.get('auth-token');
    const headers: Record<string, string> = {};
    if (authData && authData.token && !noAuth) {
        headers.authorization = `Bearer ${authData.token}`;
        // headers.authorization = `Bearer 1`;
    }

    return getGraphSdk(
        new GraphQLClient(
            (config as any)[chainId || getCurrentChainId()].graph,
            { headers },
        ),
        sdkWrapper,
    );
}

export function getLazpadApi(chainId?: ChainId, noAuth?: boolean) {
    const authData = storage.get('auth-token');
    const headers: Record<string, string> = {};
    if (authData && authData.token && !noAuth) {
        headers.authorization = `Bearer ${authData.token}`;
        // headers.authorization = `Bearer 1`;
    }
    return getLazpadSdk(
        new GraphQLClient(
            (config as any)[chainId || getCurrentChainId()].lazpad,
            { headers },
        ),
        sdkWrapper,
    );
}

export function getTaskApi(chainId?: ChainId, noAuth?: boolean) {
    const authData = storage.get('auth-token');
    const headers: Record<string, string> = {};
    if (authData && authData.token && !noAuth) {
        headers.authorization = `Bearer ${authData.token}`;
        // headers.authorization = `Bearer 1`;
    }
    return getTaskSdk(
        new GraphQLClient(
            (config as any)[chainId || getCurrentChainId()].task,
            { headers },
        ),
        sdkWrapper,
    );
}
